import { getCustomFonts } from "./CustomFontsAPIs.js";

export function getFontFormatFromName(fontName) {
    const ext = fontName.split('.').pop().toLowerCase();
    switch (ext) {
      case 'otf':   return 'opentype';
      case 'ttf':   return 'truetype';
      case 'woff':  return 'woff';
      case 'woff2': return 'woff2';
      default:      return ''; // or 'application/octet-stream'
    }
  };

//  load fonts 
  export const getCustomFontsForCommunityTemplateApplied=async(FontsList)=>{
         const response=await getCustomFonts(FontsList);
                if(response!==null)
                { 
                  for (let { fontName, fontsignedUrl } of response.data) {
                    // derive a family name (strip the extension)
                    const family = fontName.replace(/\.[^/.]+$/, "");
                    // pick the right format for .otf
                    const format = getFontFormatFromName(fontName);
                    try {
                      const face = new FontFace(family, `url(${fontsignedUrl}) format('${format}')`);
                      await face.load();
                      document.fonts.add(face);
        
                      const css = `
                      @font-face {
                        font-family: '${family}';
                        src: url('${fontsignedUrl}') format('${format}');
                        font-weight: normal;
                        font-style: normal;
                      }
                    `;
                    // console.log("Fonts list css",css);
                    const styleTag = document.createElement('style');
                    styleTag.appendChild(document.createTextNode(css));
                    document.head.appendChild(styleTag);
        
                      // console.log(`Loaded font: ${family}`);
                    } catch (err) {
                      console.error(`Failed to load ${family} from ${fontsignedUrl}`, err);
                    }
                  }
                  await document.fonts.ready;
                  console.log("All custom fonts are loaded for shared templates.");
                  return response.data;
                }
  };

export const UPLOAD_CUSTOM_FONT_OPTION = "Upload-custom-font";

/** Load user + template custom fonts, register @font-face, and update editor font lists. */
export const loadCustomFontsForEditor = async ({
  fontFamilyList,
  setFontFamilyList,
  setCustomFontsList,
  templateCustomFontKeys = [],
}) => {
  let userFonts = await getCustomFonts();
  if (userFonts !== null) {
    userFonts = userFonts.data;
  } else {
    userFonts = [];
  }

  let templatefonts = [];
  if (templateCustomFontKeys?.length) {
    const templateResponse = await getCustomFonts(templateCustomFontKeys);
    if (templateResponse !== null) {
      templatefonts = templateResponse.data;
    }
  }

  const response = [...userFonts, ...templatefonts];
  if (!response.length) return;

  const fontfacelist = JSON.parse(JSON.stringify(fontFamilyList));
  for (const { fontName, fontsignedUrl } of response) {
    const family = fontName.replace(/\.[^/.]+$/, "");
    const format = getFontFormatFromName(fontName);
    try {
      const face = new FontFace(family, `url(${fontsignedUrl}) format('${format}')`);
      await face.load();
      document.fonts.add(face);
      if (!fontfacelist.includes(family)) {
        const insertAt = fontfacelist.length - 1;
        fontfacelist.splice(insertAt, 0, family);
      }

      const css = `
        @font-face {
          font-family: '${family}';
          src: url('${fontsignedUrl}') format('${format}');
          font-weight: normal;
          font-style: normal;
        }
      `;
      const styleTag = document.createElement("style");
      styleTag.appendChild(document.createTextNode(css));
      document.head.appendChild(styleTag);
    } catch (err) {
      console.error(`Failed to load ${family} from ${fontsignedUrl}`, err);
    }
  }

  await document.fonts.ready;
  setFontFamilyList(fontfacelist);
  setCustomFontsList(response);
};